module.exports.guinevere = {
  vi: {
    title: 'Guinevere trong Avalon: Lancelot và Ám sát',
    description:
      'Guinevere biết gì trong Avalon? Tìm hiểu cách cô nhìn thấy hai Lancelot, vì sao phe của họ không chắc chắn và cách tránh bị Ám sát trên nền tảng này.',
    keywords: ['Guinevere', 'Vai trò', 'Luật chơi', 'Mẹo chơi'],
  },
  pt: {
    title: 'Guinevere em Avalon: Lancelots e assassinato',
    description:
      'O que Guinevere sabe em Avalon? Entenda como vê os dois Lancelots sem saber seus lados, as trocas de lealdade e o risco de assassinato.',
    keywords: ['Guinevere', 'Papel', 'Regras', 'Dicas'],
  },
  en: {
    title: 'Guinevere in Avalon: Lancelots & Assassination',
    description:
      'What does Guinevere know in Avalon? Learn how she sees the two Lancelots, why their allegiance is uncertain and how to avoid assassination on this platform.',
    keywords: ['Guinevere', 'Role', 'Rules', 'Tips'],
  },
  ru: {
    title: 'Гвиневра в Авалоне: Ланселоты и риск убийства',
    description:
      'Кого видит Гвиневра в Авалоне? Два Ланселота без знания их стороны, смена лояльности и защита от финального убийства на платформе.',
    keywords: ['Гвиневра', 'Роль', 'Правила', 'Советы'],
  },
  'zh-TW': {
    title: '阿瓦隆女皇：蘭斯洛特資訊與刺殺規則',
    description: '阿瓦隆女皇能看到誰？了解女皇如何識別兩名蘭斯洛特、為什麼不知道各自陣營，以及本站的刺殺風險。',
    keywords: ['女皇', '角色', '規則', '攻略'],
  },
  'zh-CN': {
    title: '阿瓦隆女皇：兰斯洛特信息与刺杀规则',
    description: '阿瓦隆女皇能看到谁？了解女皇如何识别两名兰斯洛特、为什么不知道各自阵营，以及本站的刺杀风险。',
    keywords: ['女皇', '角色', '规则', '建议'],
  },
  es: {
    title: 'Ginebra en Avalon: Lancelots y asesinato',
    description:
      '¿Qué sabe Ginebra en Avalon? Conoce cómo ve a los dos Lancelots sin saber sus bandos, qué cambia al intercambiarlos y cómo evitar el asesinato.',
    keywords: ['Ginebra', 'Rol', 'Reglas', 'Consejos'],
  },
};
